import { render, staticRenderFns } from "./UserPeserta.vue?vue&type=template&id=77c3d124"
import script from "./UserPeserta.vue?vue&type=script&lang=js"
export * from "./UserPeserta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports